export const galleryImages = [
  {
    id: 1,
    title: '편안한 상담 공간',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20cozy%20counseling%20room%20interior%20with%20natural%20light%20through%20large%20window%2C%20green%20plants%2C%20soft%20neutral%20tones%2C%20ivory%20walls%2C%20wooden%20furniture%2C%20books%20on%20shelf%2C%20minimal%20clean%20design%2C%20serene%20atmosphere%2C%20professional%20psychology%20office%2C%20editorial%20photography&width=800&height=1000&seq=daon-gallery-01&orientation=portrait',
  },
  {
    id: 2,
    title: '자연과 함께하는 힐링',
    image:
      'https://readdy.ai/api/search-image?query=Peaceful%20indoor%20garden%20space%20with%20lush%20green%20plants%20near%20sunlit%20window%2C%20warm%20wooden%20floor%2C%20comfortable%20seating%2C%20botanical%20atmosphere%2C%20soft%20morning%20light%2C%20ivory%20and%20sage%20tones%2C%20wellness%20environment%2C%20editorial%20photography&width=800&height=600&seq=daon-gallery-02&orientation=landscape',
  },
  {
    id: 3,
    title: '독서와 명상의 공간',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20stack%20of%20books%20on%20wooden%20table%2C%20soft%20cushion%2C%20gentle%20natural%20light%20from%20window%2C%20potted%20plant%20nearby%2C%20warm%20ivory%20and%20beige%20tones%2C%20calm%20meditative%20atmosphere%2C%20minimal%20interior%2C%20editorial%20photography&width=800&height=600&seq=daon-gallery-03&orientation=landscape',
  },
  {
    id: 4,
    title: '회복의 순간',
    image:
      'https://readdy.ai/api/search-image?query=Serene%20nature%20inspired%20interior%20with%20gentle%20sunlight%20streaming%20through%20curtains%2C%20green%20leafy%20plant%20in%20corner%2C%20warm%20neutral%20palette%2C%20peaceful%20atmosphere%20suggesting%20recovery%20and%20growth%2C%20soft%20textures%2C%20editorial%20lifestyle%20photography&width=800&height=1000&seq=daon-gallery-04&orientation=portrait',
  },
  {
    id: 5,
    title: '소통과 공감의 장',
    image:
      'https://readdy.ai/api/search-image?query=Warm%20inviting%20community%20space%20with%20round%20wooden%20table%20and%20comfortable%20chairs%2C%20soft%20natural%20lighting%2C%20green%20plants%20around%2C%20books%20and%20journals%20on%20shelf%2C%20ivory%20walls%2C%20empathy%20and%20connection%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=daon-gallery-05&orientation=landscape',
  },
  {
    id: 6,
    title: '새로운 시작을 향해',
    image:
      'https://readdy.ai/api/search-image?query=Bright%20hopeful%20doorway%20with%20warm%20sunlight%20streaming%20in%2C%20indoor%20plants%20near%20entrance%2C%20clean%20minimal%20space%2C%20ivory%20and%20soft%20green%20tones%2C%20new%20beginnings%20symbolism%2C%20peaceful%20transition%2C%20architectural%20interior%20photography&width=800&height=600&seq=daon-gallery-06&orientation=landscape',
  },
]